import { setLoading } from "src/store/customizer/CustomizerSlice";
import { PostFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";

const appendImageField = (formData, imageValue) => {
  if (!imageValue) return;

  if (imageValue instanceof File) {
    formData.append("image", imageValue);
    return;
  }

  if (imageValue instanceof FileList || Array.isArray(imageValue)) {
    const files = imageValue instanceof FileList ? Array.from(imageValue) : imageValue;
    const firstFile = files.find((file) => file instanceof File);
    if (firstFile) {
      formData.append("image", firstFile);
    }
    return;
  }

  if (typeof imageValue === "string" && imageValue.trim() !== "") {
    formData.append("image_url", imageValue);
  }
};

export const GetGeneralCommission =
  ({ callback }) =>
  async (dispatch, getState) => {
    try {
      const response = await PostFunction({
        data: {},
        Route: UrlApi.general_commission.get,
        showalert: false,
        state: getState,
        dispatch,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const ManageGeneralCommission =
  ({ callback, values, editMode }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      const bodyFormData = new FormData();

      if (editMode && values?.id) {
        bodyFormData.append("id", values.id);
      }

      if (values.name) bodyFormData.append("name", values.name.trim());
      if (values.role) bodyFormData.append("role", values.role.trim());
      if (values.bio) bodyFormData.append("bio", values.bio.trim());
      if (values.display_order !== undefined)
        bodyFormData.append("display_order", values.display_order);
      if (values.is_active !== undefined)
        bodyFormData.append("is_active", Boolean(values.is_active));

      appendImageField(bodyFormData, values.image);

      const route = editMode
        ? UrlApi.general_commission.edit
        : UrlApi.general_commission.add;

      const response = await PostFunction({
        data: bodyFormData,
        Route: route,
        showalert: true,
        state: getState,
        isMultipart: true,
        dispatch,
      });

      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const EditGeneralCommission =
  ({ callback, id, nameFailed, dataFailed }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      const formData = new FormData();
      formData.append("id", id);
      // Convert boolean fields to proper boolean values
      if (nameFailed === "is_active") {
        formData.append(nameFailed, Boolean(dataFailed));
      } else if (nameFailed === "image") {
        appendImageField(formData, dataFailed);
      } else {
        formData.append(nameFailed, dataFailed);
      }

      const response = await PostFunction({
        data: formData,
        Route: UrlApi.general_commission.edit,
        showalert: true,
        state: getState,
        isMultipart: nameFailed === "image",
        dispatch,
      });

      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const DeleteGeneralCommission =
  ({ callback, id }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      const response = await PostFunction({
        data: { ids: id },
        Route: UrlApi.general_commission.delete,
        showalert: true,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });

      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };

